import { createAction } from 'redux-actions';
import authStorage from 'util/authStorage';

export const openFailedAlert = createAction(
	'OPEN_ALERT',
	(type = 'generic', message, option = {}) => ({
		type,
		message,
		option,
		success: false,
	}),
);

export const closeAlert = createAction('CLOSE_ALERT', type => ({ type }));

export const openSuccessAlert = createAction(
	'OPEN_ALERT',
	(type = 'generic', message, option = {}) => ({
		type,
		message,
		option,
		success: true,
	}),
);

export const errorHandleEpic = action$ =>
	action$.filter(action => action.type.includes('REJECTED')).map(action => {
		if (action.payload instanceof Error) {
			console.error(action.payload);

			return {
				type: 'OPEN_ALERT',
				payload: { type: 'generic', message: action.payload.message, option: {}, success: false },
			};
		}

		if (action.payload.payload.message === 'Access token could not be verified') {
			authStorage.removeToken();
			window.location.reload();
			return { type: 'CLEAR_TOKEN' };
		}

		return action.payload;
	});



// WEBPACK FOOTER //
// ./src/actions/alert.js